import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import BlurText from '../components/BlurText';
import AnimatedSection from '../components/AnimatedSection';
import SEO from '../components/SEO';

const popularLocations = [
  { name: 'United States', flag: '🇺🇸', code: 'US' },
  { name: 'Germany', flag: '🇩🇪', code: 'DE' },
  { name: 'United Kingdom', flag: '🇬🇧', code: 'GB' },
  { name: 'Netherlands', flag: '🇳🇱', code: 'NL' },
  { name: 'France', flag: '🇫🇷', code: 'FR' },
  { name: 'Australia', flag: '🇦🇺', code: 'AU' },
  { name: 'Canada', flag: '🇨🇦', code: 'CA' },
  { name: 'Japan', flag: '🇯🇵', code: 'JP' },
  { name: 'Sweden', flag: '🇸🇪', code: 'SE' },
  { name: 'Hong Kong', flag: '🇭🇰', code: 'HK' }
];

const basicLocations = [
  { name: 'Afghanistan', flag: '🇦🇫' },
  { name: 'Albania', flag: '🇦🇱' },
  { name: 'Algeria', flag: '🇩🇿' },
  { name: 'Andorra', flag: '🇦🇩' },
  { name: 'Angola', flag: '🇦🇴' },
  { name: 'Antigua and Barbuda', flag: '🇦🇬' },
  { name: 'Argentina', flag: '🇦🇷' },
  { name: 'Armenia', flag: '🇦🇲' },
  { name: 'Australia', flag: '🇦🇺' },
  { name: 'Austria', flag: '🇦🇹' },
  { name: 'Azerbaijan', flag: '🇦🇿' },
  { name: 'Bahamas', flag: '🇧🇸' },
  { name: 'Bahrain', flag: '🇧🇭' },
  { name: 'Bangladesh', flag: '🇧🇩' },
  { name: 'Barbados', flag: '🇧🇧' },
  { name: 'Belarus', flag: '🇧🇾' },
  { name: 'Belgium', flag: '🇧🇪' },
  { name: 'Belize', flag: '🇧🇿' },
  { name: 'Benin', flag: '🇧🇯' },
  { name: 'Bhutan', flag: '🇧🇹' },
  { name: 'Bolivia', flag: '🇧🇴' },
  { name: 'Bosnia and Herzegovina', flag: '🇧🇦' },
  { name: 'Botswana', flag: '🇧🇼' },
  { name: 'Brazil', flag: '🇧🇷' },
  { name: 'Brunei', flag: '🇧🇳' },
  { name: 'Bulgaria', flag: '🇧🇬' },
  { name: 'Burkina Faso', flag: '🇧🇫' },
  { name: 'Burundi', flag: '🇧🇮' },
  { name: 'Cambodia', flag: '🇰🇭' },
  { name: 'Cameroon', flag: '🇨🇲' },
  { name: 'Canada', flag: '🇨🇦' },
  { name: 'Cape Verde', flag: '🇨🇻' },
  { name: 'Cayman Islands', flag: '🇰🇾' },
  { name: 'Chile', flag: '🇨🇱' },
  { name: 'China', flag: '🇨🇳' },
  { name: 'Colombia', flag: '🇨🇴' },
  { name: 'Comoros', flag: '🇰🇲' },
  { name: 'Costa Rica', flag: '🇨🇷' },
  { name: 'Croatia', flag: '🇭🇷' },
  { name: 'Cuba', flag: '🇨🇺' },
  { name: 'Curaçao', flag: '🇨🇼' },
  { name: 'Cyprus', flag: '🇨🇾' },
  { name: 'Czech Republic', flag: '🇨🇿' },
  { name: 'Democratic Republic of the Congo', flag: '🇨🇩' },
  { name: 'Denmark', flag: '🇩🇰' },
  { name: 'Djibouti', flag: '🇩🇯' },
  { name: 'Dominica', flag: '🇩🇲' },
  { name: 'Dominican Republic', flag: '🇩🇴' },
  { name: 'Ecuador', flag: '🇪🇨' },
  { name: 'Egypt', flag: '🇪🇬' },
  { name: 'El Salvador', flag: '🇸🇻' },
  { name: 'Equatorial Guinea', flag: '🇬🇶' },
  { name: 'Estonia', flag: '🇪🇪' },
  { name: 'Ethiopia', flag: '🇪🇹' },
  { name: 'Fiji', flag: '🇫🇯' },
  { name: 'Finland', flag: '🇫🇮' },
  { name: 'France', flag: '🇫🇷' },
  { name: 'French Guiana', flag: '🇬🇫' },
  { name: 'Gabon', flag: '🇬🇦' },
  { name: 'Gambia', flag: '🇬🇲' },
  { name: 'Georgia', flag: '🇬🇪' },
  { name: 'Germany', flag: '🇩🇪' },
  { name: 'Ghana', flag: '🇬🇭' },
  { name: 'Greece', flag: '🇬🇷' },
  { name: 'Grenada', flag: '🇬🇩' },
  { name: 'Guadeloupe', flag: '🇬🇵' },
  { name: 'Guatemala', flag: '🇬🇹' },
  { name: 'Guinea', flag: '🇬🇳' },
  { name: 'Guinea-Bissau', flag: '🇬🇼' },
  { name: 'Guyana', flag: '🇬🇾' },
  { name: 'Haiti', flag: '🇭🇹' },
  { name: 'Honduras', flag: '🇭🇳' },
  { name: 'Hong Kong', flag: '🇭🇰' },
  { name: 'Hungary', flag: '🇭🇺' },
  { name: 'Iceland', flag: '🇮🇸' },
  { name: 'India', flag: '🇮🇳' },
  { name: 'Indonesia', flag: '🇮🇩' },
  { name: 'Iran', flag: '🇮🇷' },
  { name: 'Iraq', flag: '🇮🇶' },
  { name: 'Ireland', flag: '🇮🇪' },
  { name: 'Isle of Man', flag: '🇮🇲' },
  { name: 'Israel', flag: '🇮🇱' },
  { name: 'Italy', flag: '🇮🇹' },
  { name: 'Ivory Coast', flag: '🇨🇮' },
  { name: 'Jamaica', flag: '🇯🇲' },
  { name: 'Japan', flag: '🇯🇵' },
  { name: 'Jersey', flag: '🇯🇪' },
  { name: 'Jordan', flag: '🇯🇴' },
  { name: 'Kazakhstan', flag: '🇰🇿' },
  { name: 'Kenya', flag: '🇰🇪' },
  { name: 'Kosovo', flag: '🇽🇰' },
  { name: 'Kuwait', flag: '🇰🇼' },
  { name: 'Kyrgyzstan', flag: '🇰🇬' },
  { name: 'Laos', flag: '🇱🇦' },
  { name: 'Latvia', flag: '🇱🇻' },
  { name: 'Lebanon', flag: '🇱🇧' },
  { name: 'Lesotho', flag: '🇱🇸' },
  { name: 'Libya', flag: '🇱🇾' },
  { name: 'Lithuania', flag: '🇱🇹' },
  { name: 'Luxembourg', flag: '🇱🇺' },
  { name: 'Macau', flag: '🇲🇴' },
  { name: 'Madagascar', flag: '🇲🇬' },
  { name: 'Malawi', flag: '🇲🇼' },
  { name: 'Malaysia', flag: '🇲🇾' },
  { name: 'Maldives', flag: '🇲🇻' },
  { name: 'Mali', flag: '🇲🇱' },
  { name: 'Malta', flag: '🇲🇹' },
  { name: 'Martinique', flag: '🇲🇶' },
  { name: 'Mauritania', flag: '🇲🇷' },
  { name: 'Mauritius', flag: '🇲🇺' },
  { name: 'Mayotte', flag: '🇾🇹' },
  { name: 'Mexico', flag: '🇲🇽' },
  { name: 'Moldova', flag: '🇲🇩' },
  { name: 'Mongolia', flag: '🇲🇳' },
  { name: 'Montenegro', flag: '🇲🇪' },
  { name: 'Morocco', flag: '🇲🇦' },
  { name: 'Mozambique', flag: '🇲🇿' },
  { name: 'Myanmar', flag: '🇲🇲' },
  { name: 'Namibia', flag: '🇳🇦' },
  { name: 'Nepal', flag: '🇳🇵' },
  { name: 'Netherlands', flag: '🇳🇱' },
  { name: 'New Zealand', flag: '🇳🇿' },
  { name: 'Nicaragua', flag: '🇳🇮' },
  { name: 'Niger', flag: '🇳🇪' },
  { name: 'Nigeria', flag: '🇳🇬' },
  { name: 'North Macedonia', flag: '🇲🇰' },
  { name: 'Norway', flag: '🇳🇴' },
  { name: 'Oman', flag: '🇴🇲' },
  { name: 'Pakistan', flag: '🇵🇰' },
  { name: 'Panama', flag: '🇵🇦' },
  { name: 'Papua New Guinea', flag: '🇵🇬' },
  { name: 'Paraguay', flag: '🇵🇾' },
  { name: 'Peru', flag: '🇵🇪' },
  { name: 'Philippines', flag: '🇵🇭' },
  { name: 'Poland', flag: '🇵🇱' },
  { name: 'Portugal', flag: '🇵🇹' },
  { name: 'Puerto Rico', flag: '🇵🇷' },
  { name: 'Qatar', flag: '🇶🇦' },
  { name: 'Republic of the Congo', flag: '🇨🇬' },
  { name: 'Romania', flag: '🇷🇴' },
  { name: 'Russia', flag: '🇷🇺' },
  { name: 'Rwanda', flag: '🇷🇼' },
  { name: 'Réunion', flag: '🇷🇪' },
  { name: 'Saint Lucia', flag: '🇱🇨' },
  { name: 'Saint Vincent and the Grenadines', flag: '🇻🇨' },
  { name: 'Saudi Arabia', flag: '🇸🇦' },
  { name: 'Senegal', flag: '🇸🇳' },
  { name: 'Serbia', flag: '🇷🇸' },
  { name: 'Seychelles', flag: '🇸🇨' },
  { name: 'Sierra Leone', flag: '🇸🇱' },
  { name: 'Singapore', flag: '🇸🇬' },
  { name: 'Sint Maarten', flag: '🇸🇽' },
  { name: 'Slovakia', flag: '🇸🇰' },
  { name: 'Slovenia', flag: '🇸🇮' },
  { name: 'Somalia', flag: '🇸🇴' },
  { name: 'South Africa', flag: '🇿🇦' },
  { name: 'South Korea', flag: '🇰🇷' },
  { name: 'Spain', flag: '🇪🇸' },
  { name: 'Sri Lanka', flag: '🇱🇰' },
  { name: 'State of Palestine', flag: '🇵🇸' },
  { name: 'Suriname', flag: '🇸🇷' },
  { name: 'Sweden', flag: '🇸🇪' },
  { name: 'Switzerland', flag: '🇨🇭' },
  { name: 'Syria', flag: '🇸🇾' },
  { name: 'São Tomé and Príncipe', flag: '🇸🇹' },
  { name: 'Taiwan', flag: '🇹🇼' },
  { name: 'Tajikistan', flag: '🇹🇯' },
  { name: 'Tanzania', flag: '🇹🇿' },
  { name: 'Thailand', flag: '🇹🇭' },
  { name: 'Togo', flag: '🇹🇬' },
  { name: 'Trinidad and Tobago', flag: '🇹🇹' },
  { name: 'Tunisia', flag: '🇹🇳' },
  { name: 'Turkey', flag: '🇹🇷' },
  { name: 'Turkmenistan', flag: '🇹🇲' },
  { name: 'Uganda', flag: '🇺🇬' },
  { name: 'Ukraine', flag: '🇺🇦' },
  { name: 'United Arab Emirates', flag: '🇦🇪' },
  { name: 'United Kingdom', flag: '🇬🇧' },
  { name: 'United States', flag: '🇺🇸' },
  { name: 'United States Virgin Islands', flag: '🇻🇮' },
  { name: 'Uruguay', flag: '🇺🇾' },
  { name: 'Uzbekistan', flag: '🇺🇿' },
  { name: 'Venezuela', flag: '🇻🇪' },
  { name: 'Vietnam', flag: '🇻🇳' },
  { name: 'Yemen', flag: '🇾🇪' },
  { name: 'Zambia', flag: '🇿🇲' },
  { name: 'Zimbabwe', flag: '🇿🇼' }
];

const premiumLocations = [
  { name: 'United States', flag: '🇺🇸' },
  { name: 'United Kingdom', flag: '🇬🇧' },
  { name: 'Germany', flag: '🇩🇪' },
  { name: 'France', flag: '🇫🇷' },
  { name: 'Canada', flag: '🇨🇦' },
  { name: 'Australia', flag: '🇦🇺' },
  { name: 'Japan', flag: '🇯🇵' },
  { name: 'Netherlands', flag: '🇳🇱' },
  { name: 'Switzerland', flag: '🇨🇭' },
  { name: 'Sweden', flag: '🇸🇪' },
  { name: 'Singapore', flag: '🇸🇬' },
  { name: 'Hong Kong', flag: '🇭🇰' },
  { name: 'South Korea', flag: '🇰🇷' },
  { name: 'Italy', flag: '🇮🇹' },
  { name: 'Spain', flag: '🇪🇸' },
  { name: 'Brazil', flag: '🇧🇷' },
  { name: 'India', flag: '🇮🇳' },
  { name: 'Mexico', flag: '🇲🇽' },
  { name: 'Poland', flag: '🇵🇱' },
  { name: 'Belgium', flag: '🇧🇪' },
  { name: 'Austria', flag: '🇦🇹' },
  { name: 'Norway', flag: '🇳🇴' },
  { name: 'Denmark', flag: '🇩🇰' },
  { name: 'Finland', flag: '🇫🇮' },
  { name: 'Ireland', flag: '🇮🇪' },
  { name: 'New Zealand', flag: '🇳🇿' },
  { name: 'Portugal', flag: '🇵🇹' },
  { name: 'Czech Republic', flag: '🇨🇿' },
  { name: 'Romania', flag: '🇷🇴' },
  { name: 'Greece', flag: '🇬🇷' },
  { name: 'Turkey', flag: '🇹🇷' },
  { name: 'Russia', flag: '🇷🇺' },
  { name: 'Ukraine', flag: '🇺🇦' },
  { name: 'Israel', flag: '🇮🇱' },
  { name: 'United Arab Emirates', flag: '🇦🇪' },
  { name: 'Saudi Arabia', flag: '🇸🇦' },
  { name: 'South Africa', flag: '🇿🇦' },
  { name: 'Argentina', flag: '🇦🇷' },
  { name: 'Chile', flag: '🇨🇱' },
  { name: 'Colombia', flag: '🇨🇴' },
  { name: 'Thailand', flag: '🇹🇭' },
  { name: 'Vietnam', flag: '🇻🇳' },
  { name: 'Philippines', flag: '🇵🇭' },
  { name: 'Malaysia', flag: '🇲🇾' },
  { name: 'Indonesia', flag: '🇮🇩' },
  { name: 'Taiwan', flag: '🇹🇼' },
  { name: 'China', flag: '🇨🇳' },
  { name: 'Hungary', flag: '🇭🇺' },
  { name: 'Bulgaria', flag: '🇧🇬' },
  { name: 'Croatia', flag: '🇭🇷' },
  { name: 'Slovakia', flag: '🇸🇰' },
  { name: 'Slovenia', flag: '🇸🇮' },
  { name: 'Lithuania', flag: '🇱🇹' },
  { name: 'Latvia', flag: '🇱🇻' },
  { name: 'Estonia', flag: '🇪🇪' },
  { name: 'Luxembourg', flag: '🇱🇺' },
  { name: 'Malta', flag: '🇲🇹' },
  { name: 'Cyprus', flag: '🇨🇾' },
  { name: 'Iceland', flag: '🇮🇸' },
  { name: 'Serbia', flag: '🇷🇸' },
  { name: 'Montenegro', flag: '🇲🇪' },
  { name: 'North Macedonia', flag: '🇲🇰' },
  { name: 'Bosnia and Herzegovina', flag: '🇧🇦' },
  { name: 'Albania', flag: '🇦🇱' },
  { name: 'Kosovo', flag: '🇽🇰' },
  { name: 'Moldova', flag: '🇲🇩' },
  { name: 'Belarus', flag: '🇧🇾' },
  { name: 'Georgia', flag: '🇬🇪' },
  { name: 'Armenia', flag: '🇦🇲' },
  { name: 'Azerbaijan', flag: '🇦🇿' },
  { name: 'Kazakhstan', flag: '🇰🇿' },
  { name: 'Uzbekistan', flag: '🇺🇿' },
  { name: 'Turkmenistan', flag: '🇹🇲' },
  { name: 'Tajikistan', flag: '🇹🇯' },
  { name: 'Kyrgyzstan', flag: '🇰🇬' },
  { name: 'Mongolia', flag: '🇲🇳' },
  { name: 'Pakistan', flag: '🇵🇰' },
  { name: 'Bangladesh', flag: '🇧🇩' },
  { name: 'Sri Lanka', flag: '🇱🇰' },
  { name: 'Nepal', flag: '🇳🇵' },
  { name: 'Maldives', flag: '🇲🇻' },
  { name: 'Bhutan', flag: '🇧🇹' },
  { name: 'Cambodia', flag: '🇰🇭' },
  { name: 'Laos', flag: '🇱🇦' },
  { name: 'Myanmar', flag: '🇲🇲' },
  { name: 'Brunei', flag: '🇧🇳' },
  { name: 'Macau', flag: '🇲🇴' },
  { name: 'Qatar', flag: '🇶🇦' },
  { name: 'Kuwait', flag: '🇰🇼' },
  { name: 'Bahrain', flag: '🇧🇭' },
  { name: 'Oman', flag: '🇴🇲' },
  { name: 'Jordan', flag: '🇯🇴' },
  { name: 'Lebanon', flag: '🇱🇧' },
  { name: 'Iraq', flag: '🇮🇶' },
  { name: 'Iran', flag: '🇮🇷' },
  { name: 'Syria', flag: '🇸🇾' },
  { name: 'State of Palestine', flag: '🇵🇸' },
  { name: 'Yemen', flag: '🇾🇪' },
  { name: 'Egypt', flag: '🇪🇬' },
  { name: 'Morocco', flag: '🇲🇦' },
  { name: 'Algeria', flag: '🇩🇿' },
  { name: 'Tunisia', flag: '🇹🇳' },
  { name: 'Libya', flag: '🇱🇾' },
  { name: 'Nigeria', flag: '🇳🇬' },
  { name: 'Kenya', flag: '🇰🇪' },
  { name: 'Ghana', flag: '🇬🇭' },
  { name: 'Ethiopia', flag: '🇪🇹' },
  { name: 'Tanzania', flag: '🇹🇿' },
  { name: 'Uganda', flag: '🇺🇬' },
  { name: 'Rwanda', flag: '🇷🇼' },
  { name: 'Senegal', flag: '🇸🇳' },
  { name: 'Ivory Coast', flag: '🇨🇮' },
  { name: 'Cameroon', flag: '🇨🇲' },
  { name: 'Angola', flag: '🇦🇴' },
  { name: 'Mozambique', flag: '🇲🇿' },
  { name: 'Zimbabwe', flag: '🇿🇼' },
  { name: 'Zambia', flag: '🇿🇲' },
  { name: 'Botswana', flag: '🇧🇼' },
  { name: 'Namibia', flag: '🇳🇦' },
  { name: 'Madagascar', flag: '🇲🇬' },
  { name: 'Mauritius', flag: '🇲🇺' },
  { name: 'Seychelles', flag: '🇸🇨' },
  { name: 'Réunion', flag: '🇷🇪' },
  { name: 'Mayotte', flag: '🇾🇹' },
  { name: 'Peru', flag: '🇵🇪' },
  { name: 'Ecuador', flag: '🇪🇨' },
  { name: 'Venezuela', flag: '🇻🇪' },
  { name: 'Uruguay', flag: '🇺🇾' },
  { name: 'Paraguay', flag: '🇵🇾' },
  { name: 'Bolivia', flag: '🇧🇴' },
  { name: 'Costa Rica', flag: '🇨🇷' },
  { name: 'Panama', flag: '🇵🇦' },
  { name: 'Guatemala', flag: '🇬🇹' },
  { name: 'Honduras', flag: '🇭🇳' },
  { name: 'El Salvador', flag: '🇸🇻' },
  { name: 'Nicaragua', flag: '🇳🇮' },
  { name: 'Belize', flag: '🇧🇿' },
  { name: 'Dominican Republic', flag: '🇩🇴' },
  { name: 'Puerto Rico', flag: '🇵🇷' },
  { name: 'Jamaica', flag: '🇯🇲' },
  { name: 'Cuba', flag: '🇨🇺' },
  { name: 'Haiti', flag: '🇭🇹' },
  { name: 'Trinidad and Tobago', flag: '🇹🇹' },
  { name: 'Barbados', flag: '🇧🇧' },
  { name: 'Bahamas', flag: '🇧🇸' },
  { name: 'Cayman Islands', flag: '🇰🇾' },
  { name: 'United States Virgin Islands', flag: '🇻🇮' },
  { name: 'Curaçao', flag: '🇨🇼' },
  { name: 'Sint Maarten', flag: '🇸🇽' },
  { name: 'Guadeloupe', flag: '🇬🇵' },
  { name: 'Martinique', flag: '🇲🇶' },
  { name: 'French Guiana', flag: '🇬🇫' },
  { name: 'Suriname', flag: '🇸🇷' },
  { name: 'Guyana', flag: '🇬🇾' },
  { name: 'Fiji', flag: '🇫🇯' },
  { name: 'Papua New Guinea', flag: '🇵🇬' },
  { name: 'Andorra', flag: '🇦🇩' },
  { name: 'Isle of Man', flag: '🇮🇲' },
  { name: 'Jersey', flag: '🇯🇪' },
  { name: 'Afghanistan', flag: '🇦🇫' },
  { name: 'Antigua and Barbuda', flag: '🇦🇬' },
  { name: 'Benin', flag: '🇧🇯' },
  { name: 'Burkina Faso', flag: '🇧🇫' },
  { name: 'Burundi', flag: '🇧🇮' },
  { name: 'Cape Verde', flag: '🇨🇻' },
  { name: 'Comoros', flag: '🇰🇲' },
  { name: 'Democratic Republic of the Congo', flag: '🇨🇩' },
  { name: 'Republic of the Congo', flag: '🇨🇬' },
  { name: 'Djibouti', flag: '🇩🇯' },
  { name: 'Dominica', flag: '🇩🇲' },
  { name: 'Equatorial Guinea', flag: '🇬🇶' },
  { name: 'Gabon', flag: '🇬🇦' },
  { name: 'Gambia', flag: '🇬🇲' },
  { name: 'Grenada', flag: '🇬🇩' },
  { name: 'Guinea', flag: '🇬🇳' },
  { name: 'Guinea-Bissau', flag: '🇬🇼' },
  { name: 'Lesotho', flag: '🇱🇸' },
  { name: 'Malawi', flag: '🇲🇼' },
  { name: 'Mali', flag: '🇲🇱' },
  { name: 'Mauritania', flag: '🇲🇷' },
  { name: 'Niger', flag: '🇳🇪' },
  { name: 'Saint Lucia', flag: '🇱🇨' },
  { name: 'Saint Vincent and the Grenadines', flag: '🇻🇨' },
  { name: 'São Tomé and Príncipe', flag: '🇸🇹' },
  { name: 'Sierra Leone', flag: '🇸🇱' },
  { name: 'Somalia', flag: '🇸🇴' },
  { name: 'Togo', flag: '🇹🇬' }
];

const LocationsPage = () => {
  const [activeTab, setActiveTab] = useState('basic');

  const currentLocations = activeTab === 'basic' ? basicLocations : premiumLocations;

  return (
    <div className="locations-page">
      <SEO
        title="Proxy Locations — 150+ Countries Worldwide"
        description="Access residential proxies in 150+ countries including US, UK, Germany, Japan, Australia, and more. Rotating residential basic and premium proxies with global coverage."
        path="/locations"
      />
      <Navbar />

      <AnimatedSection>
        <section className="locations-hero">
          <div className="container">
            <h1 className="locations-title">
              <BlurText text="Proxy Locations" delay={62} direction="top" />
            </h1>
            <p className="locations-subtitle">
              <BlurText text={`Access proxies from ${basicLocations.length}+ countries worldwide`} delay={62} direction="bottom" />
            </p>
          </div>
        </section>
      </AnimatedSection>

      <AnimatedSection>
        <section className="popular-locations">
        <div className="container">
          <h2 className="section-title">Most Popular Proxy Locations</h2>
          <div className="popular-grid">
            {popularLocations.map((location, index) => (
              <div className="popular-card" key={index}>
                <span className="popular-flag">{location.flag}</span>
                <span className="popular-name">{location.name}</span>
              </div>
            ))}
          </div>
        </div>
        </section>
      </AnimatedSection>

      <AnimatedSection>
        <section className="all-locations">
        <div className="container">
          <div className="locations-tabs">
            <button
              className={`locations-tab ${activeTab === 'basic' ? 'active' : ''}`}
              onClick={() => setActiveTab('basic')}
            >
              Rotating Residential Basic
            </button>
            <button
              className={`locations-tab ${activeTab === 'premium' ? 'active' : ''}`}
              onClick={() => setActiveTab('premium')}
            >
              Rotating Residential Premium
            </button>
          </div>

          <h2 className="section-title">
            All {activeTab === 'basic' ? 'Rotating Residential Basic' : 'Rotating Residential Premium'} Proxy Locations
          </h2>

          <p className="locations-count">{currentLocations.length} countries available</p>

          <div className="locations-grid">
            {currentLocations.map((location, index) => (
              <div className="location-item" key={index}>
                <span className="location-flag">{location.flag}</span>
                <span className="location-name">{location.name}</span>
              </div>
            ))}
            {currentLocations.length === 0 && (
              <div className="no-locations">
                <p>Premium locations coming soon!</p>
              </div>
            )}
          </div>
        </div>
        </section>
      </AnimatedSection>

      <Footer />
    </div>
  );
};

export default LocationsPage;
